import DeclarantSheet from "./DeclarantSheet";
import AssociationSheet from "./AssociationSheet";
import AnnexeSheet from "./AnnexeSheet";
import MembresSheet from "./MembresSheet";
import DissolutionSheet from "./DissolutionSheet";
import RadiationSheet from "./RadiationSheet";
import FinCreationSheet from "./FinCreationSheet";

export default {
    install(Vue) {
        Vue.component("a-declarant-sheet", DeclarantSheet);
        Vue.component("a-association-sheet", AssociationSheet);
        Vue.component("a-annexe-sheet", AnnexeSheet);
        Vue.component("a-membres-sheet", MembresSheet);
        Vue.component("a-dissolution-sheet", DissolutionSheet);
        Vue.component("a-radiation-sheet", RadiationSheet);
        Vue.component("a-fin-creation-sheet", FinCreationSheet);
    }
}
